/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BidbattlesInputs */

const en_bidbattles = /** @type {(inputs: BidbattlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BidBattles`)
};

/**
* | output |
* | --- |
* | "BidBattles" |
*
* @param {BidbattlesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bidbattles = /** @type {((inputs?: BidbattlesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BidbattlesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattles(inputs)
});